/* Manu AI v9 (16/10/2026) · accueil : barre « idée · sport · style · Créer ».
 * - Sport et style se choisissent dans la barre, avant « Créer avec Manu ».
 *   Sport : « Tous les sports » (exemples mélangés) ou un sport, qui filtre les exemples et les designs.
 *   Style : panneau de grandes vignettes (13 styles tendance de l'onglet Manu AI + « Choisis pour moi »).
 * - Synchro avec le texte : un exemple cliqué règle son sport et son style ; un sport ou un style écrit
 *   dans le texte (« hyrox », « varsity »…) met les boutons à jour.
 * - Le style choisi part dans le brief (s.style) : Manu ne repose pas la question du style.
 * S'appuie sur l'instance créée par assets/ai-studio.js (section._ais), chargé avant ce fichier. */
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  // Minuscules sans accents, mots séparés par une espace : « Hyrox, Rétro » → « hyrox retro »
  function norm(x) {
    return String(x || '').toLowerCase().normalize('NFD').split('').filter(function (c) { var n = c.charCodeAt(0); return n < 768 || n > 879; })
      .map(function (c) { return /[a-z0-9]/.test(c) ? c : ' '; }).join('').split(' ').filter(Boolean).join(' ');
  }
  var SPARK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/></svg>';
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  var HEROS = ['fitness', 'crossfit', 'hyrox', 'running'];
  var NICHE_OF = { running: 'running', trail: 'running', crossfit: 'cf', hyrox: 'cf', fitness: 'cf', other: 'cf' };
  var NAMES = { fitness: 'Fitness', crossfit: 'CrossFit', hyrox: 'Hyrox', running: 'Running' };
  // Sport reconnu dans le texte (mots entiers, 5 langues), dans cet ordre de priorité
  var SPORT_WORDS = [
    ['hyrox', ['hyrox']],
    ['crossfit', ['crossfit', 'cross fit', 'wod']],
    ['running', ['run', 'running', 'runner', 'runners', 'trail', 'marathon', 'semi', 'course a pied', 'jogging', 'laufen', 'correr', 'corsa', '10km', '10 km']],
    ['fitness', ['fitness', 'muscu', 'musculation', 'gym', 'bodybuilding']]
  ];

  // Bouton + panneau : ouverture, fermeture (Échap, clic dehors), un seul ouvert à la fois
  var opened = [];
  function dropdown(wrap, btn, pop, onOpen) {
    var api = {
      isOpen: function () { return !pop.hidden; },
      close: function (focusBtn) {
        if (pop.hidden) return;
        pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open');
        if (focusBtn) btn.focus();
      },
      open: function () {
        opened.forEach(function (o) { if (o !== api) o.close(); });
        pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open');
        if (onOpen) onOpen();
      }
    };
    opened.push(api);
    btn.addEventListener('click', function () { if (api.isOpen()) api.close(); else api.open(); });
    document.addEventListener('click', function (e) { if (api.isOpen() && !wrap.contains(e.target)) api.close(); });
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape' && api.isOpen()) { e.preventDefault(); api.close(true); } });
    return api;
  }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v9) return;
    var wrap = root.querySelector('[data-ais-stylepick]'), swrap = root.querySelector('[data-ais-sportpick]');
    if (!wrap) return;
    inst._v9 = true;
    var t = inst.t || {}, styles = null, ui = {};
    inst.heroStyle = null;

    /* ---------- Sport facultatif, exemples mélangés, designs par paquets ----------
       Remplace sur l'instance setNiche / exList de ai-studio.js (qui imposait un sport, CrossFit par défaut). */
    // Exemples : [libellé, phrase, vignette du style, clé du style, sport]. Sans sport : tous les sports, un par un.
    inst.exList = function (k) {
      var self = this;
      if (!k) {
        var lists = HEROS.map(function (n) { return self.exList(n); }), out = [], i, j;
        for (i = 0; i < 8; i++) for (j = 0; j < lists.length; j++) if (lists[j][i]) out.push(lists[j][i]);
        return out;
      }
      var loc = this.loc, imgs = this.styleImgs || {}, n = this.exData && this.exData.niches && this.exData.niches[k];
      if (n && n.length) return n.map(function (e) {
        return [(e.label && (e.label[loc] || e.label.fr)) || '', (e.text && (e.text[loc] || e.text.fr)) || '', (e.style && imgs[e.style]) || null, e.style || null, k];
      }).filter(function (x) { return x[0] && x[1]; });
      return (((this.t.niches || {})[k] || { ex: [] }).ex || []).map(function (x) { return [x[0], x[1], x[2] || null, null, k]; });
    };
    inst.setNiche = function (k, quiet) {
      k = HEROS.indexOf(k) > -1 ? k : null;
      var tt = this.t, n = (k && (tt.niches || {})[k]) || { ph: tt.ph_all || '' }, ex = this.exList(k);
      this.heroNiche = k;
      if (!quiet) store('aisNiche', k || 'all');
      this.root.querySelectorAll('[data-ais-niches] [data-niche]').forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-niche') || null) === k ? 'true' : 'false'); });
      if (this.ideaField) this.ideaField.placeholder = n.ph;
      if (this.promptsEl) this.promptsEl.innerHTML = ex.map(function (x, i) {
        return '<button type="button" class="ais-chip" data-ex="' + i + '">' + esc(x[0]) + '</button>';
      }).join('');
      this.paintGrid(0);
    };
    // Designs du sport (tous sans sport) par paquets de data-max ; la dernière case montre le paquet suivant
    // (retour au début après le dernier) ; s'il n'y a qu'un paquet, elle mène à la galerie complète.
    inst.paintGrid = function (page) {
      var strip = this.stripEl; if (!strip) return;
      var want = this.heroNiche ? NICHE_OF[this.heroNiche] : null, max = parseInt(strip.getAttribute('data-max'), 10) || 10;
      var lis = [].slice.call(strip.querySelectorAll('li[data-niche]'));
      var mine = lis.filter(function (li) { return !want || li.getAttribute('data-niche') === want; });
      var pages = Math.max(1, Math.ceil(mine.length / max));
      page = ((page || 0) % pages + pages) % pages;
      this.gridPage = page;
      lis.forEach(function (li) { li.hidden = true; });
      mine.slice(page * max, page * max + max).forEach(function (li) { li.hidden = false; });
      var more = strip.querySelector('[data-ais-more]'), all = strip.querySelector('[data-ais-all]');
      if (more) { more.hidden = pages < 2; var nEl = more.querySelector('[data-ais-more-n]'); if (nEl) nEl.textContent = (page + 1) + ' / ' + pages; }
      if (all) all.hidden = pages > 1;
    };
    var moreBtn = inst.stripEl && inst.stripEl.querySelector('[data-ais-more]');
    if (moreBtn) moreBtn.addEventListener('click', function () {
      inst.paintGrid((inst.gridPage || 0) + 1);
      var first = inst.stripEl.querySelector('li[data-niche]:not([hidden]) a');
      if (first) first.focus({ preventScroll: true });
    });
    // Sport de départ : ?sport= (lien pub) > dernier choix de la visite > tous les sports
    var q = ((location.search.match(/[?&]sport=([a-z]+)/i) || [])[1] || '').toLowerCase();
    if (q === 'trail') q = 'running';
    inst.setNiche(HEROS.indexOf(q) > -1 ? q : store('aisNiche'), true);
    // Sans sport choisi, Manu le déduit de l'idée : open() de ai-studio.js mettait CrossFit d'office
    var askManu = inst.askManu;
    inst.askManu = function () {
      if (this._fresh) { this._fresh = false; if (!this.heroNiche && this.s) this.s.sport = null; }
      return askManu.apply(this, arguments);
    };

    /* ---------- Sport ---------- */
    var sport = null;
    if (swrap) {
      var sbtn = swrap.querySelector('[data-ais-sportbtn]'), spop = swrap.querySelector('[data-ais-sportpop]'), sval = swrap.querySelector('[data-ais-sportbtn-v]');
      sport = dropdown(swrap, sbtn, spop, function () {
        var on = spop.querySelector('[aria-pressed="true"]'); if (on) on.focus({ preventScroll: true });
      });
      sport.paint = function () {
        var k = inst.heroNiche;
        sval.textContent = k ? (NAMES[k] || k) : (t.sport_any || 'Tous les sports');
        sbtn.classList.toggle('is-set', !!k);
      };
      // Les options portent data-niche : ai-studio.js les gère déjà (setNiche) ; ici on ferme et on repeint
      spop.addEventListener('click', function (e) { if (e.target.closest('[data-niche]')) sport.close(true); });
    }

    // Exemples : texte seul (pas de vignette de style sur les puces) ; bouton sport à jour
    var plain = function () {
      if (!inst.promptsEl) return;
      inst.promptsEl.querySelectorAll('.ais-chip--img').forEach(function (b) {
        b.classList.remove('ais-chip--img');
        var img = b.querySelector('img'); if (img) img.remove();
      });
    };
    var setNiche = inst.setNiche;
    inst.setNiche = function () { setNiche.apply(this, arguments); plain(); if (sport) sport.paint(); };
    plain();
    if (sport) sport.paint();

    /* ---------- Style ---------- */
    var btn = wrap.querySelector('[data-ais-stylebtn]'), pop = wrap.querySelector('[data-ais-stylepop]');
    var btnImg = wrap.querySelector('[data-ais-stylebtn-img]'), btnVal = wrap.querySelector('[data-ais-stylebtn-v]');
    var anyLabel = function () { return ui.any || t.style_any || 'Choisis pour moi'; };
    var current = function () {
      if (!inst.heroStyle || !styles) return null;
      return styles.filter(function (s) { return s.key === inst.heroStyle; })[0] || null;
    };
    var paintBtn = function () {
      var st = current();
      btnImg.innerHTML = st && st.img ? '<img src="' + esc(sized(st.img, 120)) + '" alt="" width="40" height="40">' : SPARK;
      btnImg.classList.toggle('has-img', !!(st && st.img));
      btnVal.textContent = st ? st.label : anyLabel();
      btn.classList.toggle('is-set', !!st);
    };
    var paintPop = function () {
      pop.querySelectorAll('[data-st]').forEach(function (b) {
        b.setAttribute('aria-pressed', (b.getAttribute('data-st') || null) === inst.heroStyle ? 'true' : 'false');
      });
    };
    var renderPop = function () {
      pop.innerHTML = '<p class="ais-stylepop__title">' + esc(t.style_title || 'Choisis un style') + '</p>' +
        '<ul class="ais-stylepop__grid" role="list">' +
        '<li><button type="button" class="ais-sty ais-sty--any" data-st=""><span class="ais-sty__img">' + SPARK + '</span><span class="ais-sty__name">' + esc(anyLabel()) + '</span></button></li>' +
        (styles || []).map(function (st) {
          return '<li><button type="button" class="ais-sty" data-st="' + esc(st.key) + '">' +
            '<span class="ais-sty__img">' + (st.img ? '<img src="' + esc(sized(st.img, 240)) + '" alt="" width="120" height="120" loading="lazy">' : '<span aria-hidden="true">' + esc(st.label.charAt(0)) + '</span>') + '</span>' +
            '<span class="ais-sty__name">' + esc(st.label) + '</span></button></li>';
        }).join('') + '</ul>';
      paintPop();
    };
    var loading = null;
    var load = function () {
      if (styles) return Promise.resolve(styles);
      if (!loading) loading = inst.loadStyles().then(function (d) {
        styles = (d && d.styles) || []; ui = (d && d.ui) || {};
        renderPop(); paintBtn();
        return styles;
      }, function () { styles = []; return styles; });
      return loading;
    };
    var setStyle = function (k) {
      inst.heroStyle = k || null;
      if (styles) { paintPop(); paintBtn(); } else load();
    };
    var style = dropdown(wrap, btn, pop, function () {
      load().then(function () {
        if (!styles.length) { style.close(); btn.hidden = true; return; }
        var on = pop.querySelector('[aria-pressed="true"]') || pop.querySelector('[data-st]');
        if (on) on.focus({ preventScroll: true });
      });
    });
    pop.addEventListener('click', function (e) {
      var b = e.target.closest('[data-st]'); if (!b) return;
      setStyle(b.getAttribute('data-st')); style.close(true);
    });

    /* ---------- Synchro avec le texte ---------- */
    // Exemple cliqué (ai-studio.js a déjà rempli le champ) : son style, puis son sport
    if (inst.promptsEl) inst.promptsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ex]'); if (!b) return;
      var ex = inst.exList(inst.heroNiche)[+b.getAttribute('data-ex')];
      if (!ex) return;
      lastSport = ex[4] || null; lastStyle = ex[3] || null;
      if (ex[3]) setStyle(ex[3]);
      if (ex[4] && ex[4] !== inst.heroNiche) inst.setNiche(ex[4]);
    });
    // Texte écrit : un sport ou un style cité met les boutons à jour (seulement quand ce qui est cité change,
    // pour ne pas défaire un choix fait à la main ensuite)
    var lastSport = null, lastStyle = null, timer = null;
    var detect = function () {
      var txt = ' ' + norm(inst.ideaField.value) + ' ';
      var sp = null;
      SPORT_WORDS.some(function (r) { if (r[1].some(function (w) { return txt.indexOf(' ' + w + ' ') > -1; })) { sp = r[0]; return true; } return false; });
      if (sp && sp !== lastSport) { lastSport = sp; if (sp !== inst.heroNiche) inst.setNiche(sp); }
      load().then(function () {
        var hit = null;
        styles.some(function (st) {
          var words = [st.key, st.label].map(norm).filter(function (w) { return w.length > 2; });
          if (words.some(function (w) { return txt.indexOf(' ' + w + ' ') > -1; })) { hit = st.key; return true; }
          return false;
        });
        if (hit && hit !== lastStyle) { lastStyle = hit; if (hit !== inst.heroStyle) setStyle(hit); }
      });
    };
    if (inst.ideaField) inst.ideaField.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(detect, 400); });

    // Le sport et le style choisis sont rappelés sous la première bulle du visiteur : on voit ce que Manu a reçu
    var open = inst.open, user = inst.user;
    inst.open = function (seed) { this._tagNext = !!(seed && seed.idea); return open.apply(this, arguments); };
    inst.user = function () {
      user.apply(this, arguments);
      if (!this._tagNext) return;
      this._tagNext = false;
      var st = current(), html = '';
      if (this.heroNiche) html += '<span class="ais-msg__tag"><b>' + esc(t.sport_word || 'Sport') + '</b>' + esc(NAMES[this.heroNiche] || this.heroNiche) + '</span>';
      if (st) html += '<span class="ais-msg__tag">' + (st.img ? '<img src="' + esc(sized(st.img, 80)) + '" alt="" width="20" height="20">' : '') + '<b>' + esc(t.style_word || 'Style') + '</b>' + esc(st.label) + '</span>';
      var msgs = this.thread.querySelectorAll('.ais-msg--user'), last = msgs[msgs.length - 1];
      if (html && last) last.insertAdjacentHTML('beforeend', '<p class="ais-msg__tags">' + html + '</p>');
    };

    // Le style choisi entre dans le brief à chaque ouverture du panneau de Manu (reset est appelé par open)
    var reset = inst.reset;
    inst.reset = function () { reset.apply(this, arguments); this._fresh = true; if (this.heroStyle && this.s) this.s.style = this.heroStyle; };
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
